exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".slideshow{display:flex;justify-content:center;align-items:center;height:280px;position:relative}.intro,.kernpunten{padding:var(--item-padding-large) 0;display:flex;justify-content:center}.kernpunten{background:#eee}.slideshow h1{color:#fff;position:absolute;z-index:2;top:120px}.slideshow .slide{position:absolute;width:100%;display:flex}.slideshow .slide-1{background:#49a2de;justify-content:flex-end}.slideshow .slide-2{background:#023960;justify-content:flex-start;animation-name:slidefade;animation-duration:12s;animation-iteration-count:infinite}@keyframes slidefade{0%,30%{opacity:0}50%,80%{opacity:1}to{opacity:0}}@media only screen and (max-width:600px){.slideshow .slide img{filter:brightness(.8)}.slideshow h1{text-shadow:2px 2px #0004}.kernpunten ul{flex-direction:column}.kernpunten li:not(:last-child){margin-bottom:var(--item-margin)}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-b2b2176e","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/content-home.vue
// module id = 61
// module chunks = 0